import React, { useEffect, useState } from "react";
import { Resource } from "../../../api/common";
import useAxios from "axios-hooks";
import {
   Image,
   Button,
   Form,
   Input,
   InputNumber,
   message,
   Collapse,
   Select,
   DatePicker,
   Radio,
   Spin,
   AutoComplete
} from "antd";
import { useHistory } from "react-router";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { useFlagsmith } from "flagsmith-react";
import Modal from "antd/lib/modal/Modal";
import { useForm } from "antd/lib/form/Form";
import { getImagePath } from "../../../utils/getImagePath";
import { Mixpanel } from "../../../utils/tracking/mixpanel";
import { Events } from "../../../utils/tracking/tracking.events";
import { useBuilding } from "../../../contexts/building/index";
import { getAxiosInstance } from "../../../utils/axios";
import { useAuth } from "../../../contexts/auth/index";

const { Panel } = Collapse;
const { Option } = Select;
const layout = {
   labelCol: { span: 6 },
   wrapperCol: { span: 16 }
};

const PassportCluster = ({ passportCluster, material, onClose }: any) => {
   const history = useHistory();
   const { pathname }: any = useLocation();
   const [t] = useTranslation();
   const [visible, setVisible] = React.useState(false);
   const [confirmLoading, setConfirmLoading] = React.useState(false);
   const [form] = useForm();
   const [isRequestSent, setRequestSent] = React.useState(
      passportCluster.request_status
   );
   const [firstPassport] = passportCluster?.passports;
   const { buildings } = useBuilding();
   const [requestSelectedBuildingId, setRequestSelectedBuildingId] =
      React.useState<any>();
   const [requestOperations, setRequestOperations] = React.useState<any>([]);
   const [fetchOperationsLoading, setFetchOperationsLoading] =
      React.useState<any>(false);
   const [amountValue, setAmountValue] = React.useState(passportCluster.amount);
   const [requestSelectedOpId, setRequestSelectedOpId] = React.useState<any>();
   const [requestSelectedCluster, setRequestSelectedCluster] =
      React.useState<any>({});
   const [deliveryType, setDeliveryType] = React.useState<any>(1);
   const [locations, setLocations] = useState<any>();
   const [locationsOrg, setLocationsOrg] = useState<any>();
   const [valueLocation, setValueLocation] = useState<any>();
   const [selectedLocation, setSelectedLocation] = useState<any>();
   const [locationAPI, setLocationAPI] = useState<any>([]);
   const [locationDropDownOpen, setLocationDropDownOpen] = useState<any>(false);
   const [isNewLocation, setIsNewLocation] = useState<any>(false);
   const { user: currentUser } = useAuth();
   const isPrivateOwner =
      currentUser &&
      currentUser["attributes"] &&
      currentUser["attributes"]["custom:user_type"] === "private-owner";
   const [userScopes, setUserScope] = React.useState<any>([]);
   const passportIdentifiers = passportCluster?.passports
      .map((passport: any) => {
         return passport?.passport_identifier;
      })
      .filter(Boolean);

   useEffect(() => {
      if (
         !isPrivateOwner &&
         passportCluster?.passport_specification_building_id &&
         passportCluster?.operations_id
      ) {
         setRequestSelectedBuildingId(
            passportCluster?.passport_specification_building_id
         );
         setRequestSelectedOpId(passportCluster?.operations_id);
      }
   }, [isPrivateOwner]);

   const [{ data, loading: postLoading, error: postError }, executePost] =
      useAxios(
         {
            url: requestSelectedBuildingId
               ? `${Resource.path.createMaterialRequestV2(
                    requestSelectedBuildingId,
                    requestSelectedOpId
                 )}`
               : `${Resource.path.createMaterialRequestV2Hub()}`,
            method: "POST",
            timeout: 900000
         },
         {
            manual: true,
            useCache: false
         }
      );

   const sendMaterialRequest = (passportCluster: any) => {
      setVisible(true);
      setRequestSelectedCluster(passportCluster);
   };

   const showPassportDetails = (passport: any) => {
      Mixpanel.track("View Passport Details - Catalogue", {
         "Passport Id": passport.id
      });
      history.push({
         pathname: `${pathname}/${material?.id}/passports/${passport.id}`,
         state: { passport, material }
      });
   };

   const totalAmount = ({ passports }: any) => {
      let total = 0;
      passports.forEach((item: any) => {
         total = total + parseFloat(item.amount);
      });

      return total;
   };

   const handleOk = () => {
      setConfirmLoading(true);
      let materialRequestValues: any;
      form
         .validateFields()
         .then((result) => {
            console.log(result, material, requestSelectedCluster);
            materialRequestValues = result;
            let data = { ...result, passport: firstPassport, material };

            const buildingData = buildings.filter((building: any) => {
               return building.id === result.building_id;
            });
            data = {
               proposal_price: result.price_proposal,
               building_name: result.building_id ? buildingData.pop().name : "",
               product_name: material.product_name,
               amount: result.quantity,
               categories: material.categories,
               delivery_date: result.delivery_date,
               product_group_id: material.product_group_id,
               unit: material.amount_unit,
               product_group: material.product_group.label,
               selling_id: requestSelectedCluster.selling_id,
               comments: result?.comments,
               material_location_places_api: isNewLocation
                  ? selectedLocation
                  : {},
               isNewLocation,
               locations_id: !isNewLocation ? selectedLocation : null
            };
            if (requestSelectedBuildingId == undefined) {
               delete data.building_name;
            }

            executePost({
               data
            })
               .then(() => {
                  Mixpanel.track(Events.Material_Request.name, {
                     "Material Name": material?.product_name,
                     "Material Manufacturer": material?.manufacturer,
                     "Price proposal": +materialRequestValues?.priceProposal,
                     "Material ID": material?.id,
                     "Material State": passportCluster?.condition,
                     "Material Installation/Removal":
                        passportCluster?.deconstructability,
                     "Material Pollutant Load":
                        passportCluster.custom_pollutance,
                     "Request Quantity": +materialRequestValues?.quantity
                  });

                  setConfirmLoading(false);
                  setRequestSent(true);
                  setRequestSelectedCluster({});
                  setRequestSelectedBuildingId(null);
                  setRequestOperations([]);
                  setRequestSelectedOpId(null);
                  form.resetFields();
                  setDeliveryType(1);
                  setVisible(false);
                  onClose();
                  message.success(
                     t("materialRequestForm.materialRequestSentSuccessMessage")
                  );
               })
               .catch((error) => {
                  console.log(error);
                  setVisible(false);
                  setConfirmLoading(false);
                  form.resetFields();
                  setDeliveryType(1);
                  onClose();
                  message.error("Something went wrong, please try again!");
               });
         })
         .catch((error) => {
            console.log(error);
            setConfirmLoading(false);
         });
   };

   const handleCancel = () => {
      setConfirmLoading(false);
      setRequestSent(false);
      setRequestSelectedCluster({});
      setRequestSelectedBuildingId(null);
      setRequestOperations([]);
      setRequestSelectedOpId(null);
      form.resetFields();
      setDeliveryType(1);
      setVisible(false);
   };

   const onBuildingSelect = async (value: any) => {
      setRequestOperations([]);
      setRequestSelectedOpId(null);
      const axios = await getAxiosInstance();
      setRequestSelectedBuildingId(value);
      setFetchOperationsLoading(true);
      await axios
         .get(`${Resource.path.operations}/${value}`)
         .then((response) => {
            if (response?.data?.data?.result) {
               const records = response?.data?.data?.result.filter(
                  (resp: any) => {
                     return (
                        resp.operation_status === "IN_PROGRESS" &&
                        resp.operation_type !== "deconstruction"
                     );
                  }
               );
               console.log(records);
               setRequestOperations(records);
               setFetchOperationsLoading(false);
            }
         })
         .catch((error) => {
            console.log(error);
         });
   };

   const [{ data: dataLocations, loading: dataLocationsLoading }] = useAxios(
      {
         url: `${Resource.path.getLocationsDemandHub}`,
         method: "GET"
      },
      { useCache: false, manual: false }
   );

   const [
      { data: dataPlaces, loading: getPlaces },
      findPlace,
      cancelRequestLocation
   ] = useAxios(
      {
         url: `${Resource.path.getLocationsHub}`,
         method: "POST"
      },
      { useCache: false, manual: true }
   );

   useEffect(() => {
      if (currentUser?.attributes) {
         const temp = currentUser?.attributes["custom:scopes"].split(",");
         setUserScope(temp);
         if (
            temp.indexOf("material-hub") !== -1 &&
            temp.indexOf("material-passport") !== -1
         ) {
            setDeliveryType(1);
         } else if (
            temp.indexOf("material-hub") === -1 &&
            temp.indexOf("material-passport") !== -1
         ) {
            setDeliveryType(2);
         } else if (
            temp.indexOf("material-hub") !== -1 &&
            temp.indexOf("material-passport") === -1
         ) {
            setDeliveryType(1);
         }
      }
      if (dataLocations?.data && dataLocations?.data) {
         const temp = dataLocations?.data.map((value: any) => {
            const { id, name } = value;
            return {
               value: `existing_${id}`,
               label: name
            };
         });
         setLocations(temp);
         setLocationsOrg(temp);
      }
      if (
         dataPlaces?.data &&
         dataPlaces?.data?.locations &&
         dataPlaces?.data?.locations.length > 0
      ) {
         setLocationDropDownOpen(true);
      }
   }, [currentUser, dataLocations, dataPlaces]);

   return (
      <>
         <div className="passport-item">
            {!!passportCluster?.passport_images?.length && (
               <figure>
                  {passportCluster?.passport_images.map((image: any) => {
                     return (
                        <Image
                           width={120}
                           height={120}
                           src={getImagePath(image)}
                           fallback="data:image/png;base64,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"
                        />
                     );
                  })}
               </figure>
            )}
            <div className="passport-details">
               <dl>
                  <dt>{t("materialDashboard.condition")}</dt>
                  <dd>{passportCluster.condition}</dd>
                  <dt>{t("materialDashboard.deconstructability")}</dt>
                  <dd>{passportCluster.deconstructability}</dd>
                  {passportCluster.custom_pollutance && (
                     <>
                        <dt>{t("materialDashboard.pollutance")}</dt>
                        <dd>{passportCluster.custom_pollutance}</dd>
                     </>
                  )}
                  {passportCluster?.selling_price && (
                     <>
                        <dt>{"price"}</dt>
                        <dd>
                           {passportCluster.selling_price}{" "}
                           <b>€/{material.product_unit}</b>
                        </dd>
                     </>
                  )}
               </dl>
               <div className="actions">
                  {
                     /* @TODO: show actions if operation > selling > details
          <div className="actions">
            {totalAmount(passportCluster)} {material.product_unit}
          </div>
          */
                     // Show form field if in catalogue or match
                  }

                  {!isRequestSent && (
                     <div className="form-field">
                        <InputNumber
                           value={amountValue}
                           onChange={(value: any) => {
                              setAmountValue(value);
                           }}
                        ></InputNumber>
                        <strong>{material.product_unit}</strong>
                     </div>
                  )}
               </div>
            </div>
            <div className="passport-availability-details">
               {passportCluster.end_date_deconstruction && (
                  <span className="availability">
                     {t("materialDashboard.availability")}:{" "}
                     {moment(passportCluster.end_date_deconstruction).format(
                        "DD.MM.YYYY"
                     )}
                  </span>
               )}

               <>
                  {isRequestSent
                     ? t("materialRequestForm.requestSent")
                     : amountValue > 0 && (
                          <Button
                             type="primary"
                             shape="round"
                             onClick={() => {
                                sendMaterialRequest(passportCluster);
                             }}
                          >
                             {t("materialRequestForm.sendRequestBtn")}
                          </Button>
                       )}
                  {isRequestSent
                     ? t("materialRequestForm.requestSent")
                     : amountValue == 0 && (
                          <Button type="primary" shape="round" disabled>
                             Out of stock
                          </Button>
                       )}
               </>
            </div>
            <Modal
               title={t("materialRequestForm.requestFormTitle")}
               visible={visible}
               okText={"Send"}
               onOk={handleOk}
               confirmLoading={confirmLoading}
               onCancel={handleCancel}
               destroyOnClose
               afterClose={() => {
                  form.resetFields();
                  setDeliveryType(1);
               }}
            >
               <div className="requestform">
                  <div className="product">
                     <h3>
                        {material?.manufacturer} {material.product_name}
                     </h3>
                  </div>
                  <Form
                     {...layout}
                     name="request_form"
                     form={form}
                     initialValues={{
                        delivery_date:
                           passportCluster?.start_date_deconstruction
                              ? moment(
                                   passportCluster.start_date_deconstruction
                                )
                              : moment(passportCluster.start_date_construction),
                        quantity: amountValue
                     }}
                  >
                     {userScopes.indexOf("material-hub") === -1 &&
                        userScopes.indexOf("material-passport") !== -1 && (
                           <Form.Item
                              name="building_id"
                              label={t("materialRequestForm.building")}
                              rules={[{ required: true }]}
                           >
                              <Select onSelect={onBuildingSelect}>
                                 {buildings &&
                                    buildings.map((building: any) => (
                                       <Option value={building.id}>
                                          {building.name}
                                       </Option>
                                    ))}
                              </Select>
                           </Form.Item>
                        )}
                     {userScopes.indexOf("material-hub") === -1 &&
                        requestOperations &&
                        userScopes.indexOf("material-passport") !== -1 && (
                           <Form.Item
                              name="operation_id"
                              label={t("materialRequestForm.operation")}
                              rules={[{ required: true }]}
                           >
                              <Select
                                 loading={fetchOperationsLoading}
                                 onSelect={(value: any) => {
                                    setRequestSelectedOpId(value);
                                 }}
                              >
                                 {requestOperations.map((operation: any) => (
                                    <Option value={operation.id}>
                                       {operation.name
                                          ? operation.name
                                          : operation.operation_type}
                                    </Option>
                                 ))}
                              </Select>
                           </Form.Item>
                        )}
                     <Form.Item
                        name="delivery_date"
                        label={t("materialRequestForm.deliveryDate")}
                        rules={[{ required: true }]}
                     >
                        <DatePicker />
                     </Form.Item>
                     <Form.Item
                        name="quantity"
                        label={t("materialRequestForm.quantity")}
                        rules={[{ required: true }]}
                     >
                        <InputNumber
                           addonAfter={material.product_unit}
                           min={1}
                        />
                     </Form.Item>
                     <Form.Item
                        name="price_proposal"
                        label={t("materialRequestForm.priceProposal")}
                        rules={[{ required: true }]}
                     >
                        <InputNumber
                           addonAfter={"€/" + material.product_unit}
                           min={1}
                        />
                     </Form.Item>
                     <Form.Item
                        name="comments"
                        label={t("materialRequestForm.comments")}
                     >
                        <Input.TextArea />
                     </Form.Item>
                     {isPrivateOwner &&
                        userScopes.indexOf("material-hub") !== -1 &&
                        userScopes.indexOf("material-passport") !== -1 && (
                           <Form.Item
                              label={t("materialRequestForm.deliverTo")}
                           >
                              <Radio.Group
                                 onChange={({ target: { value } }) => {
                                    setDeliveryType(value);
                                 }}
                                 value={deliveryType}
                              >
                                 <Radio.Button value={1}>
                                    {t("materialRequestForm.address")}
                                 </Radio.Button>
                                 <Radio.Button value={2}>
                                    {t("materialRequestForm.building")}
                                 </Radio.Button>
                              </Radio.Group>
                           </Form.Item>
                        )}
                     {isPrivateOwner &&
                        deliveryType === 2 &&
                        userScopes.indexOf("material-hub") !== -1 &&
                        userScopes.indexOf("material-passport") !== -1 && (
                           <Form.Item
                              name="building_id"
                              label={t("materialRequestForm.building")}
                              rules={[{ required: true }]}
                           >
                              <Select onSelect={onBuildingSelect}>
                                 {buildings &&
                                    buildings.map((building: any) => (
                                       <Option value={building.id}>
                                          {building.name}
                                       </Option>
                                    ))}
                              </Select>
                           </Form.Item>
                        )}
                     {isPrivateOwner &&
                        deliveryType === 2 &&
                        userScopes.indexOf("material-hub") !== -1 &&
                        requestOperations &&
                        userScopes.indexOf("material-passport") !== -1 && (
                           <Form.Item
                              name="operation_id"
                              label={t("materialRequestForm.operation")}
                              rules={[{ required: true }]}
                           >
                              <Select
                                 loading={fetchOperationsLoading}
                                 onSelect={(value: any) => {
                                    setRequestSelectedOpId(value);
                                 }}
                              >
                                 {requestOperations.map((operation: any) => (
                                    <Option value={operation.id}>
                                       {operation.name
                                          ? operation.name
                                          : operation.operation_type}
                                    </Option>
                                 ))}
                              </Select>
                           </Form.Item>
                        )}
                     {isPrivateOwner && deliveryType === 1 && (
                        <Form.Item
                           name="location"
                           label={t("materialRequestForm.address")}
                           rules={[
                              {
                                 required: true,
                                 message: `${t(
                                    "materialRequestForm.enterAddress"
                                 )}`
                              },
                              ({}) => ({
                                 validator(_, value) {
                                    if (
                                       selectedLocation === undefined ||
                                       selectedLocation === null
                                    ) {
                                       return Promise.reject(
                                          new Error(
                                             `${t(
                                                "materialRequestForm.pleaseSelectValidAddress"
                                             )}`
                                          )
                                       );
                                    }
                                    if (value) return Promise.resolve();
                                 }
                              })
                           ]}
                        >
                           <AutoComplete
                              open={locationDropDownOpen}
                              notFoundContent={getPlaces ? <Spin /> : null}
                              value={valueLocation}
                              options={locations}
                              onSelect={(value) => {
                                 cancelRequestLocation();
                                 setLocationDropDownOpen(false);
                                 const selected = locations.filter(
                                    (rec: any) => {
                                       return rec.value === value;
                                    }
                                 );

                                 const labelValue = selected.pop().label;
                                 setValueLocation(labelValue);
                                 const temp = value.split("_");
                                 setIsNewLocation(temp[0] === "new");
                                 if (temp[0] === "new") {
                                    setSelectedLocation(locationAPI[temp[1]]);
                                 } else {
                                    setSelectedLocation(temp[1]);
                                 }

                                 form.setFieldsValue({ location: labelValue });
                              }}
                              onChange={(value) => {
                                 setValueLocation(value);
                                 console.log("value", value);
                                 setLocationDropDownOpen(true);
                              }}
                              onSearch={async (searchText: string) => {
                                 cancelRequestLocation();
                                 setLocationDropDownOpen(true);
                                 if (searchText.length === 0) {
                                    setLocations(locationsOrg);
                                 } else if (searchText.length > 0) {
                                    let temp = locationsOrg.filter(
                                       (rec: any) => {
                                          return (
                                             rec?.value &&
                                             rec?.label
                                                .toLowerCase()
                                                .includes(
                                                   searchText.toLowerCase()
                                                )
                                          );
                                       }
                                    );
                                    console.log(temp, locationsOrg);
                                    if (
                                       temp.length === 0 &&
                                       searchText.length > 10
                                    ) {
                                       await findPlace({
                                          data: {
                                             address: `${searchText}`
                                          }
                                       });
                                    }

                                    if (
                                       temp.length === 0 &&
                                       dataPlaces?.data &&
                                       dataPlaces?.data?.locations &&
                                       dataPlaces?.data?.locations.length > 0
                                    ) {
                                       const tempLocations =
                                          dataPlaces?.data?.locations.map(
                                             (rec: any, key: any) => {
                                                if (rec && rec?.Label) {
                                                   return {
                                                      value: `new_${key}`,
                                                      label: rec?.Label
                                                   };
                                                }
                                             }
                                          );
                                       console.log(
                                          "tempLocations",
                                          tempLocations
                                       );
                                       setLocationAPI(
                                          dataPlaces?.data?.locations
                                       );
                                       temp = tempLocations;
                                    }
                                    setLocations(temp);
                                    setLocationDropDownOpen(true);
                                 }
                              }}
                              placeholder={t(
                                 "materialRequestForm.enterAddress"
                              )}
                              onFocus={() => {
                                 setLocationDropDownOpen(true);
                              }}
                           ></AutoComplete>
                        </Form.Item>
                     )}
                  </Form>
               </div>
            </Modal>

            {!!passportCluster.passports.length && (
               <div className="passports">
                  <Collapse defaultActiveKey={[0]} ghost>
                     <Panel
                        header={
                           passportCluster.passports.length + " passport(s)"
                        }
                        key="1"
                     >
                        {passportCluster.passports.map((p: any) => {
                           return (
                              p?.passport_identifier && (
                                 <span
                                    className="passport-id"
                                    onClick={() => showPassportDetails(p)}
                                 >
                                    <span className="light">#</span>
                                    {p?.passport_identifier}
                                 </span>
                              )
                           );
                        })}
                     </Panel>
                  </Collapse>
               </div>
            )}
         </div>
      </>
   );
};

export const PassportList = ({ material, onClose }: any) => {
   const [passports, setPassports] = useState<any>([]);
   const [t] = useTranslation();
   const { isLoading: isLoadingFlag, hasFeature } = useFlagsmith();

   const { user: currentUser } = useAuth();
   const isPrivateOwner =
      currentUser &&
      currentUser["attributes"] &&
      currentUser["attributes"]["custom:user_type"] === "private-owner";

   const [{ data, loading: getLoading, error: getError }, refetch] = useAxios(
      {
         url: material?.building_id
            ? `${Resource.path.getClusteredPassports}/list/${material.id}`
            : `${Resource.path.getClusteredPassportsHub}/list/${material.id}`,
         method: "GET"
      },
      { useCache: false }
   );

   useEffect(() => {
      if (data?.data) {
         const passports = data?.data;
         if (passports) {
            setPassports(passports);
         }
      }
   }, [data]);

   useEffect(() => {
      if (data?.data) {
         const passportList = data?.data;
         if (passportList) {
            setPassports(passportList);
         }
      }
   }, [data]);

   if (getLoading) {
      (window as any).NProgress.start();
   } else {
      (window as any).NProgress.done();
   }

   if (getLoading)
      return (
         <div className="loading">
            <Spin tip={t("common.loading")} />
         </div>
      );

   return (
      <>
         <div className="passport-list-header">
            {material.amount && (
               <h2>
                  {t("materialDashboard.availableAmount")} /{" "}
                  {t("materialDashboard.passports")}
               </h2>
            )}
            {material.amount && (
               <p>
                  {material.amount} {material.unit}{" "}
                  {t("materialDashboard.available")}
               </p>
            )}
         </div>
         <div className="passport-list">
            {passports.map((passport: any) => {
               return (
                  <>
                     <PassportCluster
                        passportCluster={passport}
                        passport={passport}
                        key={passport.id}
                        material={material}
                        onClose={onClose}
                     />
                  </>
               );
            })}
         </div>
      </>
   );
};
